import axios from 'axios';

/**
 * Description
 * @param {String} providerId
 * @param {String} siteId
 * @returns {Object} response from the sever.
 */
// eslint-disable-next-line import/prefer-default-export
export const getSiteDetails = ({
  providerId,
  siteId,
  patientId,
  patientLocation = '',
  patientLocationStateCode,
  dfd = false,
}) => {
  const queryParams = `site_id=${siteId}&patient_id=${patientId}&patient_location=${patientLocation}&patient_location_state_code=${patientLocationStateCode}`;
  let url = `/admin/get-practitioners-details/${providerId}?${queryParams}`;
  if (dfd) {
    url = `/member_self_serve/${providerId}/practitioner_details?${queryParams}`;
  }
  return axios.get(url).then((r) => r.data);
};

/**
 * Fetches practitioner details from the redesigned call center endpoint.
 * Uses practitioner_site_attributes_view for filter-matching IDs.
 * @param {Object} params
 * @param {String} params.providerId
 * @param {String} params.siteId
 * @returns {Promise<Object>} Response data from the server
 */
export const getCallCenterPractitionerDetails = ({
  providerId,
  siteId,
  patientId,
  patientLocationStateCode,
}) => 
  axios
    .get(`/admin/practitioner-site-details/${providerId}`, {
      params: {
        site_id: siteId,
        cred: true,
        patient_id: patientId,
        patient_location_state_code: patientLocationStateCode,
      },
    })
    .then((r) => r.data);

/**
 * Fetches payor side site IDs for a practitioner
 * @param {Object} params - The parameters object
 * @param {String} params.providerId - The provider ID
 * @param {Array<String>} params.siteIds - Array of site IDs
 * @returns {Promise<Object>} Response data from the server
 */
export const fetchPayorSideSiteIds = ({ providerId, siteIds }) =>
  axios
    .get(`/api/v1/practitioners/${providerId}/fetch_payor_side_site_ids`, {
      params: { site_ids: siteIds },
    })
    .then((r) => r.data);

export const intakeApptRoleEnum = {
  clinician: 0,
  coordinator: 1,
  generic_profile_clinician: 2,
  intern_provider: 3,
};
